import AnalysisLevel from "./AnalysisLevel"

const allAnalysisLevels = [
    AnalysisLevel.Account,
    AnalysisLevel.Hierarchy,
    AnalysisLevel.CustomGroup,
]
export const defaultDimensions = ['Category|Level1CategoryName','Category|Level2CategoryName'];

export const dimensions = [{
    description: null,
    dimension: "Level1CategoryName",
    dimensionCategory: "Category",
    displayName: "Level 1 Category Name",
    categoryDisplayName: "Category",
    id: 63,
    analysisLevels: allAnalysisLevels,
    templateOption: "GICS"
},
{
    description: null,
    dimension: "Level2CategoryName",
    dimensionCategory: "Category",
    displayName: "Level 2 Category Name",
    categoryDisplayName: "Category",
    id: 64,
    analysisLevels: allAnalysisLevels,
    templateOption: "GICS"
},
{
    description: null,
    dimension: "Level1GICSName",
    dimensionCategory: "ClassificationGICS",
    displayName: "GICS Sector",
    categoryDisplayName: "ClassificationGICS",
    id: 1,
    analysisLevels: allAnalysisLevels,
    templateOption: "GICS"
},
{
    description: null,
    dimension: "Level2GICSName",
    dimensionCategory: "ClassificationGICS",
    displayName: "GICS Industry Group",
    categoryDisplayName: "ClassificationGICS",
    id: 3,
    analysisLevels: allAnalysisLevels,
},
{
    description: null,
    dimension: "Level3GICSName",
    dimensionCategory: "ClassificationGICS",
    displayName: "GICS Industry",
    categoryDisplayName: "ClassificationGICS",
    id: 4,
    analysisLevels: allAnalysisLevels
},
{
    description: null,
    dimension: "Level4GICSName",
    dimensionCategory: "ClassificationGICS",
    displayName: "GICS Sub Industry",
    categoryDisplayName: "ClassificationGICS",
    id: 5,
    analysisLevels: allAnalysisLevels,
},
// {
//     description: null,
//     dimension: "Level1CategoryName",
//     dimensionCategory: "Category",
//     displayName: "Level 1 Category Name",
//     categoryDisplayName: "Category",
//     id: 6,
//     analysisLevels: allAnalysisLevels,
//     templateOption: "Category"
// },
// {
//     description: null,
//     dimension: "Level2CategoryName",
//     dimensionCategory: "Category",
//     displayName: "Level 2 Category Name",
//     categoryDisplayName: "Category",
//     id: 7,
//     analysisLevels: allAnalysisLevels,
//     templateOption: "Category"
// },
{
    description: null,
    dimension: "Level1GroupName",
    dimensionCategory: "AccountGroupHierarchy",
    displayName: "Level 1 Group Name",
    categoryDisplayName: "AccountGroupHierarchy",
    id: 7,
    analysisLevels: [AnalysisLevel.Hierarchy]
},
{
    description: null,
    dimension: "Level2GroupName",
    dimensionCategory: "AccountGroupHierarchy",
    displayName: "Level 2 Group Name",
    categoryDisplayName: "AccountGroupHierarchy",
    id: 7,
    analysisLevels: [AnalysisLevel.Hierarchy]
},
{
    description: null,
    dimension: "Level3GroupName",
    dimensionCategory: "AccountGroupHierarchy",
    displayName: "Level 3 Group Name",
    categoryDisplayName: "AccountGroupHierarchy",
    id: 7,
    analysisLevels: [AnalysisLevel.Hierarchy]
},
{
    description: null,
    dimension: "Level4GroupName",
    dimensionCategory: "AccountGroupHierarchy",
    displayName: "Level 4 Group Name",
    categoryDisplayName: "AccountGroupHierarchy",
    id: 7,
    analysisLevels: [AnalysisLevel.Hierarchy]
},
{
    description: null,
    dimension: "Level5GroupName",
    dimensionCategory: "AccountGroupHierarchy",
    displayName: "Level 5 Group Name",
    categoryDisplayName: "AccountGroupHierarchy",
    id: 7,
    analysisLevels: [AnalysisLevel.Hierarchy]
},
{
    description: null,
    dimension: "Level6GroupName",
    dimensionCategory: "AccountGroupHierarchy",
    displayName: "Level 6 Group Name",
    categoryDisplayName: "AccountGroupHierarchy",
    id: 7,
    analysisLevels: [AnalysisLevel.Hierarchy]
},
{
    description: null,
    dimension: "Level7GroupName",
    dimensionCategory: "AccountGroupHierarchy",
    displayName: "Level 7 Group Name",
    categoryDisplayName: "AccountGroupHierarchy",
    id: 7,
    analysisLevels: [AnalysisLevel.Hierarchy]
},
{
    description: null,
    dimension: "Level3CategoryName",
    dimensionCategory: "Category",
    displayName: "Level 3 Category Name",
    categoryDisplayName: "Category",
    id: 8,
    analysisLevels: allAnalysisLevels,
},
{
    description: null,
    dimension: "Level4CategoryName",
    dimensionCategory: "Category",
    displayName: "Level 4 Category Name",
    categoryDisplayName: "Category",
    id: 9,
    analysisLevels: allAnalysisLevels,
},
{
    description: null,
    dimension: "Level5CategoryName",
    dimensionCategory: "Category",
    displayName: "Level 5 Category Name",
    categoryDisplayName: "Category",
    id: 10,
    analysisLevels: allAnalysisLevels,
},
{
    description: null,
    dimension: "CountryName",
    dimensionCategory: "Region",
    displayName: "Country",
    categoryDisplayName: "Region",
    id: 37,
    analysisLevels: allAnalysisLevels,
},
{
    description: null,
    dimension: "BBEuro",
    dimensionCategory: "Region",
    displayName: "BB Euro",
    categoryDisplayName: "Region",
    id: 11,
    analysisLevels: allAnalysisLevels,
},
{
    description: null,
    dimension: "BBGlobalAggregate",
    dimensionCategory: "Region",
    displayName: "BB Global Aggregate",
    categoryDisplayName: "Region",
    id: 12,
    analysisLevels: allAnalysisLevels,
},
{
    description: null,
    dimension: "BBGlobalAggregateExUS",
    dimensionCategory: "Region",
    displayName: "BB Global Aggregate Ex US",
    categoryDisplayName: "Region",
    id: 13,
    analysisLevels: allAnalysisLevels,
},
{
    description: null,
    dimension: "IRASWorldRegion1",
    dimensionCategory: "Region",
    displayName: "IRAS World Region 1",
    categoryDisplayName: "Region",
    id: 14,
    analysisLevels: allAnalysisLevels,
},
{
    description: null,
    dimension: "IRASWorldRegion2",
    dimensionCategory: "Region",
    displayName: "IRAS World Region 2",
    categoryDisplayName: "Region",
    id: 15,
    analysisLevels: allAnalysisLevels,
},
{
    description: null,
    dimension: "MSCIEconomic",
    dimensionCategory: "Region",
    displayName: "MSCI Economic",
    categoryDisplayName: "Region",
    id: 16,
    analysisLevels: allAnalysisLevels,
},
{
    description: null,
    dimension: "MSCIRegion1",
    dimensionCategory: "Region",
    displayName: "MSCI Region 1",
    categoryDisplayName: "Region",
    id: 17,
    analysisLevels: allAnalysisLevels,
},
{
    description: null,
    dimension: "MSCIRegion2",
    dimensionCategory: "Region",
    displayName: "MSCI Region 2",
    categoryDisplayName: "Region",
    id: 18,
    analysisLevels: allAnalysisLevels,
},
{
    description: null,
    dimension: "MSCIRegion3",
    dimensionCategory: "Region",
    displayName: "MSCI Region 3",
    categoryDisplayName: "Region",
    id: 19,
    analysisLevels: allAnalysisLevels,
},
{
    description: null,
    dimension: "MSCIRegion4",
    dimensionCategory: "Region",
    displayName: "MSCI Region 4",
    categoryDisplayName: "Region",
    id: 20,
    analysisLevels: allAnalysisLevels,
},
{
    description: null,
    dimension: "MSCIRegion5",
    dimensionCategory: "Region",
    displayName: "MSCI Region 5",
    categoryDisplayName: "Region",
    id: 21,
    analysisLevels: allAnalysisLevels,
},
{
    description: null,
    dimension: "MSCIRegion6",
    dimensionCategory: "Region",
    displayName: "MSCI Region 6",
    categoryDisplayName: "Region",
    id: 22,
    analysisLevels: allAnalysisLevels,
},
{
    description: "",
    dimension: "MarketCapSet1BandRangeName",
    dimensionCategory: "MarketCapBand",
    displayName: "Market Cap Set 1",
    categoryDisplayName: "MarketCapBand",
    id: 23,
    analysisLevels: allAnalysisLevels,
},
{
    description: "",
    dimension: "MarketCapSet2BandRangeName",
    dimensionCategory: "MarketCapBand",
    displayName: "Market Cap Set 2",
    categoryDisplayName: "MarketCapBand",
    id: 24,
    analysisLevels: allAnalysisLevels,
},
{
    description: "",
    dimension: "MarketCapSet3BandRangeName",
    dimensionCategory: "MarketCapBand",
    displayName: "Market Cap Set 3",
    categoryDisplayName: "MarketCapBand",
    id: 25,
    analysisLevels: allAnalysisLevels,
},
{
    description: "",
    dimension: "MarketCapSet4BandRangeName",
    dimensionCategory: "MarketCapBand",
    displayName: "Market Cap Set 4",
    categoryDisplayName: "MarketCapBand",
    id: 26,
    analysisLevels: allAnalysisLevels,
},
{
    description: "",
    dimension: "MarketCapSet13BandRangeName",
    dimensionCategory: "MarketCapBand",
    displayName: "Market Cap Set 5",
    categoryDisplayName: "MarketCapBand",
    id: 26,
    analysisLevels: allAnalysisLevels,
},
{
    description: "",
    dimension: "EffectiveDurationSet1BandRangeName",
    dimensionCategory: "EffectiveDurationBand",
    displayName: "Effective Duration Set 1",
    categoryDisplayName: "EffectiveDurationBand",
    id: 27,
    analysisLevels: allAnalysisLevels,
},
{
    description: "",
    dimension: "EffectiveDurationSet2BandRangeName",
    dimensionCategory: "EffectiveDurationBand",
    displayName: "Effective Duration Set 2",
    categoryDisplayName: "EffectiveDurationBand",
    id: 28,
    analysisLevels: allAnalysisLevels,
},
{
    description: "",
    dimension: "EffectiveDurationSet3BandRangeName",
    dimensionCategory: "EffectiveDurationBand",
    displayName: "Effective Duration Set 3",
    categoryDisplayName: "EffectiveDurationBand",
    id: 29,
    analysisLevels: allAnalysisLevels,
},
{
    description: "",
    dimension: "EffectiveDurationSet4BandRangeName",
    dimensionCategory: "EffectiveDurationBand",
    displayName: "Effective Duration Set 4",
    categoryDisplayName: "EffectiveDurationBand",
    id: 30,
    analysisLevels: allAnalysisLevels,
},
{
    description: null,
    dimension: "IssuerName",
    dimensionCategory: "Asset",
    displayName: "Issuer Name",
    categoryDisplayName: "Asset",
    id: 31,
    analysisLevels: allAnalysisLevels,
},
{
    description: null,
    dimension: "AssetName",
    dimensionCategory: "Asset",
    displayName: "Holdings",
    categoryDisplayName: "Asset",
    id: 32,
    analysisLevels: allAnalysisLevels,
},
{
    description: null,
    dimension: "RiskCountryCode",
    dimensionCategory: "Asset",
    displayName: "Country of Risk",
    categoryDisplayName: "Asset",
    id: 33,
    analysisLevels: allAnalysisLevels,
},
{
    description: null,
    dimension: "TradeCountryCode",
    dimensionCategory: "Asset",
    displayName: "Country of Trade",
    categoryDisplayName: "Asset",
    id: 34,
    analysisLevels: allAnalysisLevels,
},
{
    description: null,
    dimension: "CountryOfDomicile",
    dimensionCategory: "Asset",
    displayName: "Country Of Domicile",
    categoryDisplayName: "Asset",
    id: 35,
    analysisLevels: allAnalysisLevels,
},
{
    description: null,
    dimension: "AccountBusinessID",
    dimensionCategory: "Account",
    displayName: "Account Name",
    categoryDisplayName: "Account",
    id: 36,
    analysisLevels: [AnalysisLevel.CustomGroup, AnalysisLevel.Hierarchy]
},
// {
//     description: null,
//     dimension: "CustomEffectiveDurationBand",
//     dimensionCategory: "EffectiveDurationBand",
//     displayName: "Custom Effective Duration Set",
//     categoryDisplayName: "EffectiveDurationBand",
//     id: 37,
//     analysisLevels: allAnalysisLevels,
// },
// {
//     description: null,
//     dimension: "CustomMarketCapBand",
//     dimensionCategory: "MarketCapBand",
//     displayName: "Custom Market Cap Set",
//     categoryDisplayName: "MarketCapBand",
//     id: 38,
//     analysisLevels: allAnalysisLevels,

// },
{
    description: null,
    dimension: "ISIN",
    dimensionCategory: "Asset",
    displayName: "ISIN",
    categoryDisplayName: "Asset",
    id: 39,
    analysisLevels: allAnalysisLevels,
},
{
    description: null,
    dimension: "SEDOL",
    dimensionCategory: "Asset",
    displayName: "SEDOL",
    categoryDisplayName: "Asset",
    id: 40,
    analysisLevels: allAnalysisLevels,
},
{
    description: null,
    dimension: "CUSIP",
    dimensionCategory: "Asset",
    displayName: "CUSIP",
    categoryDisplayName: "Asset",
    id: 41,
    analysisLevels: allAnalysisLevels,
},
{
    description: null,
    dimension: "TickerID",
    dimensionCategory: "Asset",
    displayName: "TickerID",
    categoryDisplayName: "Asset",
    id: 42,
    analysisLevels: allAnalysisLevels,
},
{
    description: null,
    dimension: "HoldingTypeName",
    dimensionCategory: "HoldingType",
    displayName: "Holding Type Name",
    categoryDisplayName: "HoldingType",
    id: 47,
    analysisLevels: allAnalysisLevels,
},
{
    description: null,
    dimension: "HoldingAdjustmentType",
    dimensionCategory: "HoldingType",
    displayName: "Holding Adjustment Type",
    categoryDisplayName: "HoldingType",
    id: 42,
    analysisLevels: allAnalysisLevels,
},
{
    description: null,
    dimension: "HoldingFeeType",
    dimensionCategory: "HoldingType",
    displayName: "Holding Fee Type",
    categoryDisplayName: "HoldingType",
    id: 43,
    analysisLevels: allAnalysisLevels,
},
{
    description: null,
    dimension: "HoldingOtherType",
    dimensionCategory: "HoldingType",
    displayName: "Holding Other Type",
    categoryDisplayName: "HoldingType",
    id: 44,
    analysisLevels: allAnalysisLevels,
},
{
    description: null,
    dimension: "HoldingPrincipalIncomeType",
    dimensionCategory: "HoldingType",
    displayName: "Holding Principal Income Type",
    categoryDisplayName: "HoldingType",
    id: 45,
    analysisLevels: allAnalysisLevels,
},
{
    description: null,
    dimension: "HoldingTaxType",
    dimensionCategory: "HoldingType",
    displayName: "Holding Tax Type",
    categoryDisplayName: "HoldingType",
    id: 46,
    analysisLevels: allAnalysisLevels,
},
{
    description: null,
    dimension: "CurrencyTypeName",
    dimensionCategory: "CurrencyType",
    displayName: "Currency Type Name",
    categoryDisplayName: "Currency Type",
    id: 48,
    analysisLevels: allAnalysisLevels,
},
{
    description: null,
    dimension: "AIPInstrumentID",
    dimensionCategory: "Asset",
    displayName: "AIP Instrument ID",
    categoryDisplayName: "Asset",
    id: 49,
    analysisLevels: allAnalysisLevels,
},
{
    description: null,
    dimension: "AssetCurrency",
    dimensionCategory: "Asset",
    displayName: "Asset Currency",
    categoryDisplayName: "Asset",
    id: 50,
    analysisLevels: allAnalysisLevels,
},
{
    description: null,
    dimension: "AssetIssueType",
    dimensionCategory: "Asset",
    displayName: "Asset Issue Type",
    categoryDisplayName: "Asset",
    id: 51,
    analysisLevels: allAnalysisLevels,
},
{
    description: null,
    dimension: "AssetIssueTypeSourceName",
    dimensionCategory: "Asset",
    displayName: "Asset Issue Type Source Name",
    categoryDisplayName: "Asset",
    id: 52,
    analysisLevels: allAnalysisLevels,
},
{
    description: null,
    dimension: "OmniumAssetID",
    dimensionCategory: "Asset",
    displayName: "Omnium Asset ID",
    categoryDisplayName: "Asset",
    id: 53,
    analysisLevels: allAnalysisLevels,
},
{
    description: null,
    dimension: "MIUAssetID",
    dimensionCategory: "Asset",
    displayName: "MIU Asset ID",
    categoryDisplayName: "Asset",
    id: 54,
    analysisLevels: allAnalysisLevels,
},
{
    description: null,
    dimension: "RegionLevel00Name",
    dimensionCategory: "FlattenedRegion",
    displayName: "Level 1 Region of Bchmk",
    categoryDisplayName: "Region of Benchmark",
    id: 55,
    analysisLevels: allAnalysisLevels,
},
{
    description: null,
    dimension: "RegionLevel01Name",
    dimensionCategory: "FlattenedRegion",
    displayName: "Level 2 Region of Bchmk",
    categoryDisplayName: "Region of Benchmark",
    id: 56,
    analysisLevels: allAnalysisLevels,
},
{
    description: null,
    dimension: "RegionLevel02Name",
    dimensionCategory: "FlattenedRegion",
    displayName: "Level 3 Region of Bchmk",
    categoryDisplayName: "Region of Benchmark",
    id: 57,
    analysisLevels: allAnalysisLevels,
},
{
    description: null,
    dimension: "RegionLevel03Name",
    dimensionCategory: "FlattenedRegion",
    displayName: "Level 4 Region of Bchmk",
    categoryDisplayName: "Region of Benchmark",
    id: 58,
    analysisLevels: allAnalysisLevels,
},
{
    description: null,
    dimension: "RegionLevel04Name",
    dimensionCategory: "FlattenedRegion",
    displayName: "Level 5 Region of Bchmk",
    categoryDisplayName: "Region of Benchmark",
    id: 59,
    analysisLevels: allAnalysisLevels,
},
{
    description: null,
    dimension: "RegionLevel05Name",
    dimensionCategory: "FlattenedRegion",
    displayName: "Level 6 Region of Bchmk",
    categoryDisplayName: "Region of Benchmark",
    id: 60,
    analysisLevels: allAnalysisLevels,
},
{
    description: null,
    dimension: "RegionLevel06Name",
    dimensionCategory: "FlattenedRegion",
    displayName: "Level 7 Region of Bchmk",
    categoryDisplayName: "Region of Benchmark",
    id: 61,
    analysisLevels: allAnalysisLevels,
},
{
    description: null,
    dimension: "RegionLevel07Name",
    dimensionCategory: "FlattenedRegion",
    displayName: "Level 8 Region of Bchmk",
    categoryDisplayName: "Region of Benchmark",
    id: 62,
    analysisLevels: allAnalysisLevels,
},
]